export const iconFontAwesomeHumanitarianPeopleRobbery = (
	<i className="fa-solid fa-people-robbery"></i>
);
